import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  sidebarBadgeRefreshTick: 0
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
    state.sidebarMinimize = false
  },
  toggleSidebarMobile (state) {
    state.sidebarMinimize = false
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    Vue.set(state, variable, value)
  }
}

export default new Vuex.Store({
  state,
  mutations
})
